import { render } from "./1WhySharksAreImportant.vue?vue&type=template&id=3706f1b7&scoped=true"
import script from "./1WhySharksAreImportant.vue?vue&type=script&lang=js"
export * from "./1WhySharksAreImportant.vue?vue&type=script&lang=js"

import "./1WhySharksAreImportant.vue?vue&type=style&index=0&id=3706f1b7&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3706f1b7"

export default script